import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaFileAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { handleOrderChangeOfPersonWikis } from "../../store/actions/wikiActions";
let listDrag;

const WikiDocReorder = (props) => {
  const [updatedOrder, setUpdatedOrder] = useState([]);
  const [athleteId, setAthleteId] = useState([]);
  const [changesMade, setChangesMade] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.documents?.length > 0 && !changesMade) {
      setUpdatedOrder(props.documents);
      setAthleteId(
        props.documents[0].forAdvocate
          ? props.documents[0].wikiAdvocate
          : props.documents[0].wikiAthlete
      );
    }
  }, [props.documents]);

  const handleOnDragEnd = (result) => {
    props.changesMade(true);
    setChangesMade(true);
    if (!result.destination) return;
    const items = Array.from(updatedOrder);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setUpdatedOrder(items);
  };
  const handleSaveOrder = () => {
    const copyArray = JSON.parse(JSON.stringify(updatedOrder));
    copyArray.map((value, index) => (value.order = index + 1));
    const submissionArray = copyArray.map((value) => value.id);
    dispatch(
      handleOrderChangeOfPersonWikis(submissionArray, props.forAdvocate)
    );
    props.setReorderOff(false);
    props.changesMade(false);
    props.handleSaveState(false);
  };
  props.handleSave && handleSaveOrder();
  listDrag = updatedOrder.map((wiki, index) => {
    return (
      <Draggable key={wiki.id} draggableId={wiki.id} index={index}>
        {(provided) => (
          <li
            className="drag-li"
            key={wiki.id}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div className="card">
              <div className="card-body">
                <div className="one">
                  <FaFileAlt size={20} color="#1678c2" />
                </div>
                <div className="two">
                  <h5>{wiki.fileName}</h5>
                </div>
              </div>
            </div>
          </li>
        )}
      </Draggable>
    );
  });
  return (
    <div className="team-section single p-0">
      {props.documents && (
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="characters">
            {(provided) => (
              <ul
                className="drag-ul"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {props.documents.length > 0 && listDrag}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </div>
  );
};

export default WikiDocReorder;
